import api from './api';

// API base URL
const API_URL = '/api/v1';

// GET /dashboard/stats: counts of the firm (the caller's own; every firm or
// `firm_id` for the super admin), of the shared legal corpus, and the
// freshness of the last completed source update.
export interface DashboardStats {
  firm: {
    documents: number;
    bank_statements: number;
    policies: number;
    members: number;
  };
  corpus: {
    legal_acts: { CH: number; TI: number; INT: number };
    articles: number;
    case_law_digests: number;
    doctrine: number;
    federal_decisions?: { BGE: number; BGER: number; BSTGER: number; BVGER: number };
  };
  sources: {
    status: string | null;
    checked_at: string | null;
  };
}

// The last documents and bank statements of the firm, newest first
export interface RecentActivity {
  type: 'document' | 'bank_statement';
  id: number | string;
  title: string | null;
  created_at: string | null;
}

export interface RecentActivityResponse {
  activities: RecentActivity[];
  total: number;
}

export const getDashboardStats = async (params: { firm_id?: string } = {}): Promise<DashboardStats> => {
  const response = await api.get(`${API_URL}/dashboard/stats`, { params });
  return response.data;
};

export const getRecentActivity = async (limit: number = 10, params: { firm_id?: string } = {}): Promise<RecentActivityResponse> => {
  const response = await api.get(`${API_URL}/dashboard/recent-activity`, {
    params: { limit, ...params },
  });
  return response.data;
};
